import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"study_use",
    list_id:"study_use_study_w_frame",
    x_column_list_arr:[
      {"key":"a_stu_name","name":"학생명","width":"90","is_show":"1"},
      {"key":"a_memo","name":"메모","width":"100","is_show":"1"},
      {"key":"row_view_per","name":"진행도(%)","width":"100","is_show":"1"},
      {"key":"row_view_detail_btn","name":"상세","width":"60","is_show":"1"},
      {"key":"a_start_date","name":"시작","width":"90","is_show":"1"},
      {"key":"a_end_date","name":"종료","width":"90","is_show":"1"},
      // {"key":"a_now_page","name":"페이지","width":"90","is_show":"1"},
      {"key":"row_view_a_now_page","name":"페이지","width":"90","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':10,
      'order_id':'a_stu_name',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_mcomp_seq","a_stu_seq","a_study_title_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;